import { Slot } from '../Modules/Slot/Model/Slot';
import { isRankCheckWaiting } from './rankCheckStatus';
import { shouldExpectAsyncRank } from './slotRankPolling';

function formatRank(rank: number | null | undefined): string {
  return rank === null || rank === undefined || rank > 500 ? '500위 밖' : `${rank}위`;
}

/** 슬롯 테이블에 표시되는 순위 텍스트와 동일 */
export function getSlotRankDisplayText(row: Pick<
  Slot,
  'today_rank' | 'yesterday_rank' | 'rank_check_status' | '_rankPending' | 'main_keyword' | 'product_url' | 'compare_url' | 'mid_single' | 'mid_compare'
>): string {
  if (!shouldExpectAsyncRank(row)) return '순위 없음';

  const status = row.rank_check_status;

  if (status === 'complete') {
    return formatRank(row.today_rank);
  }

  if (row.yesterday_rank !== null && row.yesterday_rank !== undefined) {
    return formatRank(row.yesterday_rank);
  }

  if (status === 'failed') return '실패';
  if (status === 'running') return '확인 중';
  if (isRankCheckWaiting(status) || row._rankPending) return '대기중';

  return formatRank(row.today_rank);
}
